import React from 'react';

import { useQuery } from '@gogame/query';

import {
  loadApplications,
  loadNetworks,
  loadPlatforms,
  loadClusters,
} from 'scenes/Integrations/sources/postbacks/fields';

import {
  TARGET_APPLICATION,
  TARGET_PLATFORM,
  TARGET_NETWORK,
  TARGET_CLUSTER,
  TARGET_REGISTRATION_PLATFORM,
} from '../constants';

const Preview = ({ source, value, target }) => {
  const { data } = useQuery(target, source) || [];

  if (Array.isArray(value)) {
    return data
      .filter((el) => value.includes(el.id))
      ?.map((el) => el.name)
      .join(', ');
  } else {
    return data.filter((el) => el.id === value)?.name;
  }
};

export default ({ target, value }) => {
  if (target === TARGET_APPLICATION) {
    return <Preview source={loadApplications} target={target} value={value} />;
  }

  if (target === TARGET_NETWORK) {
    return <Preview source={loadNetworks} target={target} value={value} />;
  }

  if (target === TARGET_PLATFORM || target === TARGET_REGISTRATION_PLATFORM) {
    return <Preview source={loadPlatforms} target={target} value={value} />;
  }

  if (target === TARGET_CLUSTER) {
    return <Preview source={loadClusters} target={target} value={value} />;
  }

  return value.join(', ');
};
